// import React from 'react';

export default class ProjectAssignmentEditItem {
  constructor(item) {
    if (!item) {
      this.AdHocInvoiceGroupEnabled = '';
      this.AdHocInvoiceGroup = '';
      this.UninvoiceableEnabled = '';
      this.Uninvoiceable = false;
      this.PaidOutsideOfSystemEnabled = '';
      this.PaidOutsideOfSystem = false;
      this.SearchParameters = {};
    } else {
      this.AdHocInvoiceGroupEnabled = item.adHocInvoiceGroupEnabled;
      this.AdHocInvoiceGroup = item.adHocInvoiceGroup;
      this.UninvoiceableEnabled = item.uninvoiceableEnabled;
      this.Uninvoiceable = item.uninvoiceable;
      this.PaidOutsideOfSystemEnabled = item.paidOutsideOfSystemEnabled;
      this.PaidOutsideOfSystem = item.paidOutsideOfSystem;
      this.SearchParameters = item.searchParameters;
    }
  }

  static createUninvoiceableItem() {
    return new ProjectAssignmentEditItem({
      adHocInvoiceGroupEnabled: '',
      adHocInvoiceGroup: '',
      uninvoiceableEnabled: true,
      uninvoiceable: true,
    });
  }

  // CD-5421: used by the single-row action, which posts through the same bulk endpoint with one id.
  static createPaidOutsideOfSystemItem(paidOutsideOfSystem) {
    return new ProjectAssignmentEditItem({
      adHocInvoiceGroupEnabled: '',
      adHocInvoiceGroup: '',
      uninvoiceableEnabled: '',
      paidOutsideOfSystemEnabled: true,
      paidOutsideOfSystem,
    });
  }
}
